<template>
  <div class="full-height">
    <!-- <div class="tow_disti">
             <van-tabs v-model="activei" @change="switchingi" type="card" class="mag_to_bt">
                      <van-tab title="因公"></van-tab>
                      <van-tab title="因私"></van-tab>
              </van-tabs>
        </div> -->
    <!-- <div class="trip_rigt">
              <trip-type slot="right"/>
        </div> -->
    <!-- 新版因公因私 -->
    <div class="wid_trip" v-if="leisure">
      <div class="triptypebox">
        <trip-type slot="right"/>
      </div>
    </div>
    <div class="plus-card-wrap wrap-lc">
      <van-tabs
        @click="clickLabel"
        class="stroke"
      >
        <van-tab
          v-if="this.sh[0] =='单程' ? true : false"
          name="0"
          title="单程"
        />
        <van-tab
          v-if="this.sh[1] =='往返' ? true : false"
          name="1"
          title="往返"
        />
        <van-tab
          v-if="this.sh[2] =='多程(含缺口程)' ? true : false"
          naem="2"
          title="多程"
        >
          <EndCity :ticketprompt=ticketprompt /></van-tab>

      </van-tabs>
      <!-- <van-tabs v-model="active">
            <van-tab title="标签 1">内容 1</van-tab>
            <van-tab title="标签 2">内容 2</van-tab>
            <van-tab title="标签 3">内容 3</van-tab>
            <van-tab title="标签 4">内容 4</van-tab>
          </van-tabs> -->

      <!--
        <tk-need ref="tkNeed"/> -->
      <div
        v-show="roundtrip == 0 ||roundtrip == 1"
        class="search-card"
      >
        <van-row
          v-show="pageCtrl.isShowCcsqd"
          align="center"
          class="full-width ccsqd"
          type="flex"
        >
          <van-col span="24">
            <van-cell
              :border="false"
              is-link
              @click.stop="toggle('ccsqdlist')"
            >
              <template slot="title">
                <div :class="[ccsqd.ccsqdNo ? '' : 'disable']">
                  {{ ccsqd.ccsqdNo || $t('K108', '选择出差单') }}
                </div>
              </template>
              <template
                v-show="ccsqd.ccsqdNo"
                slot="default"
              >
                <div @click.stop="showVoyage = true">
                  <van-tag
                    v-show="voyage.arriveCityName"
                    plain
                    round
                    type="warning"
                  >
                    {{ voyage.departCityName }}-{{ voyage.arriveCityName }}
                  </van-tag>
                  <span v-show="!voyage.arriveCityName && ccsqd.ccsqdNo">选择行程</span>
                </div>
              </template>
            </van-cell>
          </van-col>
        </van-row>

        <!--  -->
        <div
          v-show="roundtrip == 1 || roundtrip== 0"
          class="pad-l-16 pad-r-16"
        >
          <div
            v-show="pageCtrl.isShowCxr"
            :class="[travelerList.length > 0 ? '' : 'disable', pageCtrl.isShowCcsqd ? 'van-hairline--top' : '']"
            class="cxr van-hairline--bottom"
            @click.stop="openEmplist"
          >
            <span
              v-for="(name, index1) in travelerList"
              :key="index1"
              class="cxrname"
            > {{
              name.chName || name.cxrName || name.empName
            }} &nbsp;</span>
            <span
              v-show="travelerList.length == 0"
              class="cxrname"
            >
              {{ $t('I001', '请选择出行人') }}
            </span>
            <div v-if="pageCtrl.showtips">
              <span class="tips">
                {{ $t('F587', '已开启按差标等级管控出差标准，需要先选择出行人') }}
              </span>
            </div>
          </div>

          <div class="van-hairline--bottom">
            <van-row
              align="center"
              class="city font20 font-bold"
              type="flex"
            >
              <van-col
                :class="[tkSearchInfo.depport.cityName ? '' : 'disable']"
                span="10"
                @click="getAirportprompt(1)"
              >
                {{ departCityName || tkSearchInfo.depport.cityName || $t('C104', '出发城市') }}
                <span
                  v-show="tkSearchInfo.depport.threeCode"
                  class="font12"
                >({{
                  tkSearchInfo.depport.threeCode
                }})</span>
              </van-col>
              <van-col
                class="city-icon"
                span="4"
                @click="getAirportprompt(3)"
              >
                <ld-icon
                  class="main-color"
                  size="28"
                  type="iconzhuanhuan"
                />
              </van-col>
              <van-col
                :class="[tkSearchInfo.arrport.cityName ? '' : 'disable']"
                class="dest-city"
                span="10"
                @click="getAirportprompt(2)"
              >
                {{ arriveCityName || tkSearchInfo.arrport.cityName || $t('C105', '到达城市') }}
                <span
                  v-show="tkSearchInfo.arrport.threeCode"
                  class="font12"
                >({{
                  tkSearchInfo.arrport.threeCode
                }})</span>
              </van-col>
            </van-row>
          </div>

          <div class="van-hairline--bottom">
            <van-row
              align="center"
              class="date font20 font-bold"
              type="flex"
            >
              <van-col
                :class="[departDate.date ? '' : 'disable']"
                class="depart-date"
                span="12"
                @click="getAirportprompt('data')"
              >
                {{ departDate.monDay || $t('C106', '出发日期') }}
                <span
                  v-show="departDate.date"
                  class="date-tip"
                >{{ departDate.week }}</span>
              </van-col>

              <van-col
                v-show="roundtrip == 1"
                :class="[arriveDate.date ? '' : 'disable']"
                class="dest-date"
                span="12"
                @click="getAirportprompt('data')"
              >
                {{ arriveDate.monDay || $t('C107', '返程日期') }}
                <span
                  v-show="arriveDate.date"
                  class="date-tip"
                >{{ arriveDate.week }}</span>
              </van-col>
            </van-row>
          </div>


          <!--  -->
          <div class="ertong1">
            <div>
              <van-row
                v-show="showCabinRow"
                align="center"
                class="options "
                style="display: flex;justify-content: space-between;"
                type="flex"
              >
                <van-col>
                  <span
                    v-show="Cabintypel==0"
                    class="change-model"
                  >
                    <span
                      :class="[showCabin ? 'white bg-main' : 'main-color']"
                      class="model"
                      @click="showCabin = true"
                    >不限舱位
                    </span>
                  </span>
                  <span
                    v-show="Cabintypel==1"
                    class="change-model"
                  >
                    <span
                      :class="[showCabin ? 'white bg-main' : 'main-color']"
                      class="model"
                      @click="showCabin = true"
                    >经济
                    </span>
                    <span
                      :class="[showCabin == false ? 'white bg-main' : 'main-color']"
                      class="model"
                      @click="showCabin = false"
                    >公务/头等
                    </span>
                  </span>
                </van-col>

                <van-col
                  v-show="international == 0"
                  class="text-right"
                  span="12"
                  @click="traverNum.showPopupPicker = true"
                >
                  {{ traverNum.traverNum[0] }}{{ $t('C115', '成人') }} {{ traverNum.traverNum[1] }}{{
                    $t('C116', '儿童')
                  }} {{ traverNum.traverNum[2] }}{{ $t('C117', '婴儿') }}
                </van-col>
              </van-row>
              <div
                v-show="international == 0 && pageCtrl.roundtrip == 1"
                class="options text-right"
              >
                <span class="change-model">
                  <span
                    :class="[showIntModel ? 'white bg-main' : 'main-color']"
                    class="model"
                    @click="showIntModel = true"
                  >自选搭配</span>
                  <span
                    :class="[showIntModel == false ? 'white bg-main' : 'main-color']"
                    class="model"
                    @click="showIntModel = false"
                  >往返组合</span>
                </span>
              </div>
            </div>
            <div>
              <van-col
                v-show="tripType == 2"
              >
                <div class="ertong">
                  <van-checkbox
                    v-show="this.WithChildren==1"
                    v-model="checked"
                    @change="ErTong"
                  >
                    儿童
                  </van-checkbox>
                </div>
              </van-col>
            </div>
          </div>
          <!--  -->
          <van-cell
            v-show="international == 1 && pageCtrl.isCivil == 1 && showGp"
            center
            style="padding:10px 0"
            title="公务员购票"
          >
            <template #right-icon>
              <van-switch
                v-model="tkSearchInfo.showGpProduct"
                size="22"
              />
            </template>
          </van-cell>
        </div>
        <!-- 差旅标准 -->
        <van-cell
          v-show="tkSearchInfo.clbzTitle && tripType == 1 && !lvShow"
          :border="false"
          class="van-ellipsis"
          @click.native="clbzShow = true"
        >
          <span class="gray">本次预订使用</span>
          <span class="main-color">{{ pageCtrl.showtips ? tkSearchInfo.minzjName : '' }}</span>
          <span class="gray">的差标 ：</span>
          <span class="main-color">{{ tkSearchInfo.clbzTitle }}</span>
        </van-cell>
        <!--  -->
        <div
          v-show="roundtrip != 2"
          class="query"
        >
          <ld-button
            main
            size="lg"
            @click="searchFlights"
          >
            {{ $t('B002', '查询') }}
          </ld-button>
        </div>
      </div>
    </div>

    <ld-tabbar v-show="roundtrip == 1 || roundtrip == 0">
      <van-row class="bg-white full-width text-center font10 gray pad6 tabbar">
        <van-col
          v-if="!isXlminiprogram"
          span="6"
          @click="go(0)"
        >
          <img
            class="icon"
            src="~Assets/images/tk/tkQuery/transfer.png"
          >
          <div>{{ $t('J012', '接送机') }}</div>
        </van-col>
        <van-col
          v-if="isXlminiprogram"
          span="6"
          @click="go(1)"
        >
          <img
            class="icon"
            src="~Assets/images/tk/tkQuery/strategy.png"
          >
          <div>{{ $t('Q007', '机场攻略') }}</div>
        </van-col>
        <van-col
          v-if="!isXlminiprogram"
          span="6"
          @click="toggle('tkNeed')"
        >
          <img
            class="icon"
            src="~Assets/images/tk/tkQuery/myOrder.png"
          >
          <div> {{ $t('A106', '需求单') }}</div>
        </van-col>
        <van-col
          span="6"
          @click="go(2)"
        >
          <img
            class="icon"
            src="~Assets/images/tk/tkQuery/myOrder.png"
          >
          <div>{{ $t('A117', '我的订单') }}</div>
        </van-col>
      </van-row>
    </ld-tabbar>
    <!-- 出行人 -->
    <ld-emp-list
      ref="empList"
      :cplx="cplx"
      :person-list="ccsqd.personList"
      @selected="changeEmp"
    />
    <!-- 城市 -->
    <city
      ref="city"
      :city-type="0"
      :cplx="cplx"
      :sys-type="way"
      :tab-index="pageCtrl.roundtrip"
      @selected="cityChange"
    />

    <!-- 日历 -->

    <Ld-calendar
      ref="date"
      :type="dateType"
      allow-same-day
      end-text="回程"
      start-text="去程"
      @selected="getDate"
    />

    <!-- 舱位 -->
    <van-popup
      v-model="showCabinFilter"
      :close-on-popstate="true"
      position="bottom"
    >
      <van-picker
        ref="cabin"
        :columns="cabin.cabinObj"
        show-toolbar
        @cancel="showCabinFilter = false"
        @confirm="getCabin"
      />
    </van-popup>

    <!-- 国际票人数 -->
    <van-popup
      v-model="traverNum.showPopupPicker"
      :close-on-popstate="true"
      position="bottom"
    >
      <van-picker
        :columns="traverNum.traverNumList"
        show-toolbar
        @cancel="traverNum.showPopupPicker = false"
        @confirm="getTraverNum"
      >
        <template v-slot:columns-top>
          <van-row class="text-center font12">
            <van-col span="8">
              {{ $t('C115', '成人') }}
            </van-col>
            <van-col span="8">
              {{ $t('C116', '儿童') }}(2-12岁)
            </van-col>
            <van-col span="8">
              {{ $t('C117', '婴儿') }}(小于2岁)
            </van-col>
          </van-row>
        </template>
      </van-picker>
    </van-popup>

    <!-- 出差申请单 -->
    <ld-check-list
      ref="ccsqdlist"
      :params="params"
      type="4"
      @selected="ccsqdInfo"
    />

    <!-- 行程列表 -->
    <van-popup
      v-model="showVoyage"
      :close-on-popstate="true"
      position="bottom"
    >
      <div class="pad-16">
        <van-tag
          v-for="(info, index2) in ccsqd.routeBookList"
          :key="index2"
          :color="info.routeStatus == 3 ? '#969799' : '#ff976a'"
          plain
          round
          size="large"
          @click="changeVoyage(index2)"
        >
          <van-badge :content="badge(info)">
            {{ info.departCityName || info.departAirportName }}-{{ info.arriveCityName || info.arriveAirportName }}
            &nbsp;
          </van-badge>
        </van-tag>
      </div>
    </van-popup>

    <!-- 差旅标准 -->
    <van-popup
      v-model="clbzShow"
      :close-on-popstate="true"
      :style="{ width: '80%', maxHeight: '60%' }"
      class="clbz-popup"
    >
      <h3 class="text-center">
        差旅标准
      </h3>
      <!--      <van-cell>
          {{ tkSearchInfo.clbzTitle }}
        </van-cell>-->
      <!--			<p class="pad-16" v-html="tkSearchInfo.clbzTitle.replaceAll(';', ';</br></br>')"></p>-->
      <p
        class="pad-16"
        v-html="tkSearchInfo.clbzTitle.replace(';', ';</br></br>')"
      />
      <ld-button
        main3
        size="lg"
        @click="clbzShow = false"
      >
        我知道了
      </ld-button>
    </van-popup>
    <!--  -->
    <div
      v-show="roundtrip == 2"
      style="width: 100%;"
    >
      <van-row class="bg-white full-width text-center font10 gray pad6 tabbar">
        <van-col
          v-if="!isXlminiprogram"
          span="6"
          @click="go(0)"
        >
          <img
            class="icon"
            src="~Assets/images/tk/tkQuery/transfer.png"
            style="height: 17px; width: 20px;"
          >
          <div>{{ $t('J012', '接送机') }}</div>
        </van-col>
        <van-col
          v-if="isXlminiprogram"
          span="6"
          @click="go(1)"
        >
          <img
            class="icon"
            src="~Assets/images/tk/tkQuery/strategy.png"
            style="height: 17px; width: 20px;"
          >
          <div>{{ $t('Q007', '机场攻略') }}</div>
        </van-col>
        <van-col
          v-if="!isXlminiprogram"
          span="6"
          @click="toggle('tkNeed')"
        >
          <img
            class="icon"
            src="~Assets/images/tk/tkQuery/myOrder.png"
            style="height: 17px; width: 20px;"
          >
          <div> {{ $t('A106', '需求单') }}</div>
        </van-col>
        <van-col
          span="6"
          @click="go(2)"
        >
          <img
            class="icon"
            src="~Assets/images/tk/tkQuery/myOrder.png"
            style="height: 17px; width: 20px;"
          >
          <div>{{ $t('A117', '我的订单') }}</div>
        </van-col>
      </van-row>
    </div>
  </div>
</template>

<script>
import {Badge, Cell, Checkbox, CheckboxGroup, Field, Picker, Popup, Switch, Tab, Tabs, Tag,Dialog} from 'vant'
import ldTabbar from 'Components/ldTabbar/ldTabbar'
import EndCity from 'Views/Tk/tkQuery/dc/EndCity.vue'
import ldEmpList from 'Components/ldEmpList/index.vue'
import {formatDate} from 'Utils/dateUtil'

import tabBlock from 'Components/tab-block'
import ldButton from 'Common/ldButton'
import tripType from 'Common/tripType'
import City from 'Common/city'
import {mapGetters} from 'vuex'
//   import tkNeed from './tkNeed'
import ldCheckList from 'Components/ldCheckList/index.vue'
import {localget, localset} from 'Utils/storage'
import {getSysParameter, queryVipParameter} from 'Utils/publicApi'
import {goXlHome, isXlGp, isXlminp} from 'Utils/xltools'
import defaultMixin from '@/business/mixins/default'
import {getParameter} from 'Utils/publicApi'

export default {
  name: 'TkQuery',
  mixins: [defaultMixin],
  components: {
    ldButton,
    ldEmpList,
    tabBlock,
    City,
    tripType,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [Cell.name]: Cell,
    [Tag.name]: Tag,
    [Switch.name]: Switch,
    [Badge.name]: Badge,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Dialog.name]: Dialog,
    ldTabbar,
    //   tkNeed,
    ldCheckList,
    EndCity,
    LdCalendar: () => import('Common/ldCalendar'),
  },
  props:{
    leisure:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      sh: [
        "单程","往返"
      ],
      Cabintypel: 0,//0不限仓位 1区分舱位
      WithChildren: 0,
      clbzShow: false,
      roundtrip: 0, // 0 单程 1 往返 2需求单
      dateType: 'single',
      startDate: new Date(),
      departDate: formatDate(new Date(), 1),//出发时间
      arriveDate: {},//回程时间 formatDate(new Date(),2)
      minDate: null,
      maxDate: null,
      way: 1, //1 出发城市  2到达城市
      cabin: {
        cabinObj: [
          {value: '', text: this.$t('C108', '不限舱位')},
          {value: 'Y', text: '经济舱'},
          {value: 'C', text: '公务舱/头等舱'},
        ],
        cabin: [],
        cabinName: '',
        showPopupPicker: false
      },
      showCabin: true,
      showIntModel: false,//默认往返组合
      showCabinFilter: false,
      international: 1, //1国内 0国际查询
      cplx: '10901',
      travelerList: [],

      //国际 人数
      traverNum: {
        traverNumList: [{
          values: [1, 2, 3, 4, 5, 6, 7, 8, 9]
        },
        {
          values: ['0', 1, 2],
          defaultIndex: 0
        },
        {
          values: ['0', 1],
          defaultIndex: 0
        }],
        traverNum: [1, 0, 0],
        showPopupPicker: false,
      },
      showVoyage: false,//显示出差行程列表
      params: {'cplx': 10901},//出差申请单入参
      ccsqd: {//出差单信息
        personList: [],//申请单出行人列表
      },
      personList: [],
      voyage: {},//当前选中行程
      showGp: true,
      showCabinRow: true,
      routeId: '', // 行程单ID
      checked: false,
      child:0,
      departCityName:'', //出差模式下的出发地
      arriveCityName:'', //出差模式下的上目的地
      lvShow:false,//是否是龙旅
      business:false,//是否是因公显示儿童
      activei:0,
      ticketprompt:'',//机票提示语

    }
  },
  computed: {
    ...mapGetters({
      tkSearchInfo: 'tk/tkSearchInfo',
      tktravelerList: 'tk/travelerList',//出行人列表
      tkInttravelerList: 'tkInt/travelerList',//出行人列表
      pageCtrl: 'serviceCtrl', //页面控制信息
      tripType: 'tripType',
      userInfo: 'userInfo',
    })
  },
  mounted() {
    this.getClbz()
  },
  async created() {
    console.log(this, 'this')
    this.isLvShow()
    this.init()
    if (!this.pageCtrl.isShowCcsqd) {
      this.initParams()
    }
    this.getClbz()
    await this.getShowCabinRow()
    this.$store.commit('tk/clearFlightCache')
    // 单程 往返 多程 可控制模块
    await queryVipParameter('11601042').then(res => {
      var arr = []
      arr = res.value1.split(',')
      this.sh = arr
    })

    // 配置好号,来控制展示经济舱||不限仓位
    await queryVipParameter('11601043').then(res => {
      if (res.value1 == '0') {
        this.Cabintypel = 0
      } else if (res.value1 == '1')
        this.Cabintypel = 1
    })
    await queryVipParameter('11601041').then(res => {
      if (res.value1 == '0') {
        this.WithChildren = 0
      } else if (res.value1 == '1')
        this.WithChildren = 1
    })
    //因公查询是否展示儿童价格
    await queryVipParameter('11601051').then(res => {
      if (res.value1 == '0') {
        this.business = false
      } else if (res.value1 == '1')
        this.business = true
    })
    sessionStorage.removeItem('cache')
    let data4= await  getParameter('10918')
    data4.value1 ? this.ticketprompt=data4.value1:''

  },
  beforeRouteLeave(to, from, next) {
    // 导航离开该组件的对应路由时调用
    // 可以访问组件实例 `this`
    if (to.name == 'home') {
      this.$store.commit('tk/CLEAR_ALL')
      this.$store.commit('tkInt/CLEAR_ALL')
    }
    next()
  },
  methods: {
    ErTong() {
      if (this.checked == true) {
        this.child = 1
      } else if (this.checked == false) {
        this.child = 0
      }
    },
    // 标记
    badge(o) {
      switch (o.proType) {
        case $dict.PRO_TYPE.tk:
          return '机票' + o.xh
        case $dict.PRO_TYPE.tr:
          return '火车票' + o.xh
        case $dict.PRO_TYPE.hotel:
          return '酒店' + o.xh
      }
    },

    // 点击标签
    clickLabel(v) {
      if (this.pageCtrl.isYinCangWangFanChengRuKou && v === 1) {
        this.$toast('暂不支持因公预定往返程', 'top')
      } else {
        this.roundtrip = v
      }
    },
    init() {
      this.$store.commit('SET_SERVICE', {cplx: this.cplx})
      if (this.pageCtrl.isShowCcsqd) {
        let ccsqdId = this.$route.query.ccsqdId
        if (ccsqdId) {
          this.$api['common/vipCcsqdGetListForChoose']({
            ccsqdId: ccsqdId,
            proType: this.cplx
          }).then(res => {
            var cache = res.data || []
            if (cache.length > 0) {
              this.ccsqdInfo(cache[0])
            } else {
              this.$toast('未查询到申请单信息')
            }
          })
        }
      } else {
        if (this.pageCtrl.isDefaultName) {
          if (this.travelerList.length == 0) {
            this.userInfo.empInfo.checked = true
            this.userInfo.empInfo.clkFlag = 2
            this.travelerList.push(this.userInfo.empInfo)
            if (this.cplx == '10901') {
              this.$store.commit('tk/travelerList', this.travelerList)
            } else {
              this.$store.commit('tkInt/travelerList', this.travelerList)
            }
          }
        }
      }
      // 龙旅GP
      if (isXlminp()) {
        this.showGp = false // GP开关不显示，默认就是GP票
        if (!isXlGp()) {
          this.$store.commit('tk/tkSearchInfo', {showGpProduct: false})// 非GP的
        } else {
          this.$store.commit('tk/tkSearchInfo', {showGpProduct: true})
        }
      }
    },
    initParams() {
      let historyLog = localget('_historyLog')
      if (historyLog && historyLog.tk) {
        if (formatDate(new Date()).date > historyLog.tk.departDate.date) {
          historyLog.tk.departDate = formatDate(new Date())
        }
        this.$nextTick(() => {
          this.tkSearchInfo.queryStr = historyLog.tk.queryStr
          this.tkSearchInfo.depport = historyLog.tk.depport
          this.tkSearchInfo.arrport = historyLog.tk.arrport
          this.tkSearchInfo.arriveDate = historyLog.tk.arriveDate
          this.tkSearchInfo.departDate = historyLog.tk.departDate
          this.tkSearchInfo.ccsqd = historyLog.tk.ccsqd
          this.tkSearchInfo.voyage = historyLog.tk.voyage
        })
        if (historyLog.travelerList && historyLog.travelerList.length > 0) {
          if (this.cplx == '10901') {
            this.$store.commit('tk/travelerList', this.travelerList)
          } else {
            this.$store.commit('tkInt/travelerList', this.travelerList)
          }
        }
      } else {
        var self = this
        getSysParameter('11605013').then(res => {
          if (res.value1) {
            Object.assign(self.tkSearchInfo, {
              depport: JSON.parse(res.value1),
              arrport: {}
            })
          } else {
            queryVipParameter('11605003').then(res => {
              if (res.value1) {
                Object.assign(self.tkSearchInfo, {
                  depport: JSON.parse(res.value1),
                  arrport: {}
                })
              } else {
                Object.assign(self.tkSearchInfo, {
                  depport: {
                    international: 1,
                    cityId: '10119',
                    cityName: '北京',
                    cityPyjsm: 'BJ',
                    cityFullspell: 'beijing',
                    airportName: '首都国际机场',
                    threeCode: 'PEK',
                    jcZdCode: 'PEK',
                  },
                  arrport: {
                    international: 1,
                    cityId: '10621',
                    cityName: '上海',
                    cityPyjsm: 'SH',
                    cityFullspell: 'shanghai',
                    airportName: '虹桥国际机场',
                    threeCode: 'SHA',
                    jcZdCode: 'SHA',
                  },
                  departDate: formatDate(new Date(), 1)
                })
              }
            })
          }
        })
      }
    },
    //H5是否展示公务/头等舱
    async getShowCabinRow() {
      //H5是否展示公务/头等舱 0否 1是 默认1
      await queryVipParameter('11601029').then(res => {
        this.showCabinRow = res.value1 == '1'
      })
    },
    openEmplist() {
      if (this.pageCtrl.isShowCcsqd && !this.ccsqd.ccsqdId) {
        this.$toast('请选择出差申请单')
      } else {
        this.$refs.empList.toggle({index: 1})
      }
    },
    showDate() {//打开日期控件
      if (this.pageCtrl.isChangeDate) {
        this.$refs.date.toggle({
          defaultDate: this.roundtrip == 0 ? this.departDate.date : [this.departDate.date, this.arriveDate.date],
          minDate: this.minDate,
          maxDate: this.maxDate
        })
      }
    },
    //获取日期回调
    getDate(date) {
      if (Array.isArray(date)) {
        [this.departDate, this.arriveDate] = [formatDate(date[0]), formatDate(date[1])]
      } else {
        this.departDate = formatDate(date)
      }
    },
    getAirportprompt(way){
      console.log(way)
      if(!this.ticketprompt){
        if(way=='data'){
          this.showDate()
        }else{
          this.getAirport(way)
        }
        return
      }
      Dialog.confirm({
        message: this.ticketprompt,
      }).then(() => {

        if(way=='data'){
          this.showDate()
        }else{
          this.getAirport(way)
        }
      }).catch(()=>{
      })

    },
    getAirport(way) {//打开城市控件
      console.log('出发模式',way)
      if (!this.pageCtrl.isChangeVoyage) {
        return
      }
      if (way == 3) {
        [this.tkSearchInfo.depport, this.tkSearchInfo.arrport] = [this.tkSearchInfo.arrport, this.tkSearchInfo.depport]
        if (this.tkSearchInfo.queryStr.departAirport) { //有缓存数据获取差旅政策bug
          this.tkSearchInfo.queryStr.departAirport = this.tkSearchInfo.depport.threeCode
        }
        if (this.tkSearchInfo.queryStr.arriveAirport) { //有缓存数据获取差旅政策bug
          this.tkSearchInfo.queryStr.arriveAirport = this.tkSearchInfo.arrport.threeCode
        }
        this.getClbz()
      } else if (this.pageCtrl.isChangeVoyage) {
        this.way = way
        this.$refs.city.toggle()
      }
    },
    cityChange(info, way) {//城市回调  0国际 1 国内
      if (info.jcZdCode) {
        info.threeCode = info.jcZdCode
      } else {
        info.jcZdCode = info.threeCode
      }
      this.cityIsShow = false
      if (way == 1) {
        this.tkSearchInfo.depport = info
        if (this.tkSearchInfo.queryStr.departAirport) { //有缓存数据获取差旅政策bug
          this.tkSearchInfo.queryStr.departAirport = info.threeCode
        }
      } else {
        this.tkSearchInfo.arrport = info
        if (this.tkSearchInfo.queryStr.arriveAirport) { //有缓存数据获取差旅政策bug
          this.tkSearchInfo.queryStr.arriveAirport = info.threeCode
        }
      }
      if (this.tkSearchInfo.depport.international === 0 || this.tkSearchInfo.arrport.international === 0) {
        this.international = 0
        this.cplx = '10902'
      } else {
        this.international = 1
        this.cplx = '10901'
      }
      this.init()
      this.getClbz()
    },
    //出差申请单信息
    ccsqdInfo(info) {
      if (info.routeBookList) {
        info.routeBookList.sort((x, y) => {
          return x.xcxh - y.xcxh
        })
      }
      this.ccsqd = info
      this.personList = this.ccsqd.personList

      let index = 0
      if (this.$route.query.routeId) {
        let routeList = this.ccsqd.routeBookList || []
        routeList.forEach((o, i) => {
          if (o.routeId === this.$route.query.routeId) {
            index = i
          }
        })
      }
      this.changeVoyage(index)
    },
    // 选择行程信息
    changeVoyage(index) {
      let routeList = this.ccsqd.routeBookList || []
      if (routeList.length > 0) {
        let route = routeList[index]
        this.routeId = route.routeId

        this.$api['common/checkCcsqdPersonIsBook']({
          routeId: route.routeId,
          empIds: route.cxrId.split(','),
          empNames: route.cxr.split(','),
        }).then(res => {
          let list = res.data || []
          let isBook = false
          let isNotBook = false
          let cxr = ''
          list.forEach(o => {
            if (o.book) {
              isBook = true
              cxr += o.empName + '，'
            } else {
              isNotBook = true
            }
          })

          if (this.pageCtrl.isChongFuYuDing && isBook) {
            this.$dialog.confirm({
              title: this.$t('C474', '提示'),
              message: cxr + '已预订该行程，是否继续预订？'
            }).then(() => {
              this.ccsqd.personList = this.personList
              this.voyage = routeList[index]
              this.initRoute(this.voyage)
            }).catch(() => {
              this.qcyydcxr(isNotBook, routeList[index], list)
            })
          } else if (!this.pageCtrl.isChongFuYuDing && isBook) {
            this.$dialog.alert({
              title: this.$t('C474', '提示'),
              message: cxr + '已预订该行程，请勿重复预定！'
            })
            this.qcyydcxr(isNotBook, routeList[index], list)
          } else {
            this.ccsqd.personList = this.personList
            this.voyage = routeList[index]
            this.initRoute(this.voyage)
          }
        })
      } else {
        this.$toast('当前出差申请单无行程')
      }
    },
    // 去除已预定出行人
    qcyydcxr(isNotBook, route, list) {
      if (isNotBook) {
        let personList = []
        list.forEach(o => {
          this.personList.forEach(p => {
            if (p.empId === o.empId && !o.book) {
              personList.push(p)
            }
          })
        })
        this.ccsqd.personList = personList
        this.voyage = route
        this.initRoute(this.voyage)
      } else {
        this.voyage = {}
      }
    },
    initRoute(voyage) {
      this.tkSearchInfo.depport = {
        threeCode: voyage.departAirport,
        departAirport: voyage.departAirport,
        departAirportName: voyage.departAirportName,
        departCity: voyage.departCity,
        departCityName: voyage.departCityName,
        cityName: voyage.departCityName,
      }
      this.tkSearchInfo.arrport = {
        threeCode: voyage.arriveAirport,
        arriveAirport: voyage.arriveAirport,
        arriveAirportName: voyage.arriveAirportName,
        arriveCity: voyage.arriveCity,
        arriveCityName: voyage.arriveCityName,
        cityName: voyage.arriveCityName,
      }
      let d = new Date(voyage.departDate).valueOf()
      let n = new Date().valueOf()
      if (d > n) {
        this.departDate = formatDate(voyage.departDate)
      }
      // 处理当天行程日期问题，只处理格式为2023-09-12的情况
      if (voyage.departDate.includes('-') && voyage.departDate.length === 10) {
        n = new Date(formatDate().date).valueOf()
        if (d >= n) {
          this.departDate = formatDate(voyage.departDate)
        }
      }
      if (this.pageCtrl.isChangeDateRange > 0) {
        this.minDate = formatDate(this.ccsqd.dateBegin, -this.pageCtrl.isChangeDateRange).date
        this.maxDate = formatDate(this.ccsqd.dateEnd, this.pageCtrl.isChangeDateRange).date
      }
      this.ccsqd.personList.forEach(item => {
        if (item.checked) {
          item.checked = false
        }
      })
      let cxrId = voyage.cxrId.split(','), arr = []
      cxrId.forEach(id => {
        this.ccsqd.personList.forEach(item => {
          if (id == item.contactsId || id == item.personId || id == item.empId) {
            item.checked = true
            arr.push(item)
          }
        })
      })
      this.$store.commit('tk/travelerList', arr)
      this.changeEmp()
      this.showVoyage = false//关闭行程列表
      this.getClbz()
    },
    // 得到舱位
    getCabin() {
      let value = this.$refs.cabin.getValues()
      this.cabin.cabinName = value[0].text
      this.cabin.cabin = value[0].value
      this.showCabinFilter = false
    },
    //查询
    searchFlights() {
      console.log('15393536')
      localStorage.setItem('home','homenew')
      localStorage.setItem('tkListFilter', JSON.stringify({
        activeV: 2,
        activeFilterNum: 1,
        activeTabArr: [],
      }))
      let obj = {
        depport: this.$t('F049', '请选择') + this.$t('C104', '出发城市'),
        arrport: this.$t('F049', '请选择') + this.$t('C105', '到达城市'),
        departDate: this.$t('F049', '请选择') + this.$t('C106', '出发日期')
      }
      //因公因私是否显示儿童价传递的参数
      let showchildren
      if(this.pageCtrl.isShowCxr){//因公的判断
        showchildren= this.business //因公是否显示儿童价（后台配置）
      }else{//因私的判断
        showchildren = this.child //因私是否显示儿童价
      }

      let tkSearchInfo = {
        queryStr: {
          arriveAirport: this.tkSearchInfo.arrport.threeCode || this.tkSearchInfo.arrport.arriveAirport,
          departAirport: this.tkSearchInfo.depport.threeCode || this.tkSearchInfo.depport.departAirport,
          departDate: this.departDate.date,
          empRank: this.tkSearchInfo.minzj,
          tripType: this.tripType,
          arriveDate: this.arriveDate.date,
          showChdPrice: this.child, //是否勾选儿童票
          // 国际
          returnDate: this.arriveDate.date,
          cabinType: this.showCabin ? '' : 'C',
          aduNum: this.traverNum.traverNum[0], //  成人数量
          chdNum: this.traverNum.traverNum[1], //  儿童数量
          infNum: this.traverNum.traverNum[2], //  婴儿数量
          travelType: this.roundtrip == 1 ? 2 : 1, //  是否往返程 2往返程 空或1单程 ,
          'showStop': '',//是否经停 1显示0不显示 ,
          'airline': '',//航司二字代码 ,
          'requestId': '',//请求标记，第二次请求时回传，为第一次请求返回的值，避免重复查询数据库 ,
          'startCount': 0,//开始条数 ,
          'count': 20,//显示多少条数据
          showGpProduct: this.pageCtrl.isCivil == 1 ? (this.tkSearchInfo.showGpProduct ? 1 : 0) : 0
        },
        depport: this.tkSearchInfo.depport,
        arrport: this.tkSearchInfo.arrport,
        cabin: this.showCabin ? '' : 'C',
        departDate: this.departDate,
        arriveDate: this.arriveDate,
        travelerList: this.travelerList,
        roundtrip: 0,
        matchClbz: this.pageCtrl.isShowCxr, //是否匹配差旅标准(因公或因私)
        flights: [],
        ccsqd: this.ccsqd,//出差单信息
        voyage: this.voyage,//当前选中行程
        showIntModel: this.showIntModel,
        maxDate: this.maxDate,
        minDate: this.minDate,
        cplx: this.cplx,
        showchildren:showchildren, //因公因私是否显示儿童价根据这个判断

      }
      if (this.showIntModel) {//自由搭配
        tkSearchInfo.queryStr.returnDate = ''
      }
      for (let k in obj) {
        if (!tkSearchInfo[k] || Object.keys(tkSearchInfo[k]).length == 0) {
          this.$toast(obj[k], 'top')
          return
        }
      }
      if (this.pageCtrl.showtips && this.travelerList.length == 0) {
        this.$toast(this.$t('I001', '请选择出行人'))
        return
      }
      if (this.roundtrip == 1) {
        if (!this.arriveDate.date) {
          this.$toast('请选择返程日期', 'top')
          return
        }
        if (this.arriveDate.date < this.departDate.date) {
          this.$toast('返程日期不能早于出发日期', 'top')
          return
        }
      }
      if (this.pageCtrl.isShowCcsqd) {
        if (!this.ccsqd.ccsqdNo) {
          this.$toast('请选择出差申请单', 'top')
          return
        }
      }
      let historyLog = localget('_historyLog') || {}
      if (tkSearchInfo.depport.international === 0 || tkSearchInfo.arrport.international === 0) {//查询国际机票
        historyLog.tkInt = tkSearchInfo
        // this.tkInttravelerList=this.travelerList
        this.$store.commit('tkInt/travelerList', this.travelerList)
        this.$store.commit('tkInt/pageCtrl', this.pageCtrl)
        this.$store.commit('tkInt/tkIntSearchInfo', tkSearchInfo)
        //国内存下
        this.$store.commit('tk/tkSearchInfo', tkSearchInfo)
        historyLog.tk = tkSearchInfo
        this.$router.push('/tk/tkIntList')
      } else { //查询国内机票
        historyLog.tk = tkSearchInfo
        // this.tktravelerList=this.travelerList
        this.$store.commit('tk/travelerList', this.travelerList)
        this.$store.commit('tk/pageCtrl', this.pageCtrl)
        this.$store.commit('tk/tkSearchInfo', tkSearchInfo)
        // this.$router.push('/tk/tkList')
        //

        //区分单程访问的查询入口
        if (this.roundtrip == 0) {
          this.$router.push({
            path: '/tk/tkList',
            query: {
              routeId: this.routeId,
            }
          })
        } else {
          this.$router.push({
            path: '/tk/wfList',
            query: {
              routeId: this.routeId,
            }
          })
        }
      }
      localset('_historyLog', historyLog)
    },
    changeEmp() {
      if (this.cplx == '10901') {
        this.travelerList = this.tktravelerList
      } else if (this.cplx == '10902') {
        this.travelerList = this.tkInttravelerList
      }
      this.getClbz()
      this.departCityName='', //出差模式下的出发地
      this.arriveCityName=''
    },
    //获取差旅标准
    getClbz() {
      if (this.pageCtrl.isShowCxr && this.pageCtrl.isStart) {//判断是否需要获取差标
        let clbz = this.pageCtrl.getClbzMinZj(this.travelerList)
        this.tkSearchInfo.minzj = clbz.minzj//最低差标等级
        this.tkSearchInfo.minzjName = clbz.minzjName//最低差标等级
        let str = {
          arriveAirport: this.tkSearchInfo.queryStr.arriveAirport || this.tkSearchInfo.arrport.arriveAirport || this.tkSearchInfo.arrport.threeCode,
          departAirport: this.tkSearchInfo.queryStr.departAirport || this.tkSearchInfo.depport.arriveAirport || this.tkSearchInfo.depport.threeCode,
          empRank: this.tkSearchInfo.minzj,
          cplx: this.cplx,
          departDate: this.departDate.date,
          ccsqdId: this.ccsqd.ccsqdId,
          auditType: this.ccsqd.auditType
        }
        if (!str.arriveAirport || !str.departAirport || !this.travelerList || this.travelerList.length < 1) {
          return
        }
        try {
          this.$api['tkQuery/GetClzbByMinZj'](str)
            .then(res => {
              let cache = res.data || {}
              this.tkSearchInfo.clbzTitle = cache.clbz || ''
            })
        } catch (error) {
          console.error(error)
        }
      }
    },
    // 国际 选择出行人数量
    getTraverNum(info) {
      this.traverNum.traverNum = info
      this.traverNum.showPopupPicker = false
    },
    toggle(name) {
      this.$refs[name].toggle()
    },
    //返回
    back() {
      if (isXlminp()) {
        return goXlHome()
      }
      this.$store.commit('tk/CLEAR_ALL')
      this.$store.commit('tkInt/CLEAR_ALL')
      this.$router.push({path: '/home'})
    },
    back1() {
      console.log(this, '0000')
    },
    //tabbar 底部导航
    go(index) {
      let url = ['/car/carQuery', '/tk/strategy', '/allOrder?findType=1']
      if (index == 2) {
        this.$store.commit('SET_ORDERLISTPARAMS', {
          findType: 1,
          productType: this.cplx
        })
      }
      this.$router.push(url[index])
    },

    //对龙旅特殊处理
    isLvShow() {
      let temp = window.location.href;
      if (temp.includes("app.longlv.tmc.tianxiafen.com") || temp.includes("https://app.xinglu.com")) {
        this.lvShow = true;
      } else {
        this.lvShow = false;
      }
    },
    switchingi(v){
      // console.log("SET_TRIPTYPE", String(v+1))
      this.$store.commit('SET_TRIPTYPE', String(v+1))
      this.$nextTick(() => this.$store.commit('RENEW_SERVICE'))
    }
  },
  watch: {
    roundtrip(val) {
      if (this.pageCtrl.isChangeDate) {
        if (val == 0) {
          this.dateType = 'single'
          this.arriveDate = {}
        } else if (val == 1) {
          this.dateType = 'range'
          this.arriveDate = formatDate(this.departDate.date, 1)
        }
      }
    },
    international(val) {
      if (val == 1) {
        this.cplx = '10901'
        this.travelerList = this.tktravelerList
      } else {
        this.cplx = '10902'
        if (this.tkInttravelerList.length == 0) {
          this.$store.commit('tkInt/travelerList', this.tktravelerList)
        }
        this.travelerList = this.tkInttravelerList
      }
    },
    pageCtrl:{
      handler(val){
        if(val.isShowCcsqd){
          if(this.tkSearchInfo.businesssingle){
            let businesssingle=this.tkSearchInfo.businesssingle[0]
            this.departCityName=businesssingle.departCityName
            this.arriveCityName=businesssingle.arriveCityName
          }
        }
        if(val.isShowCcsqd===false){
          this.departCityName=''
          this.arriveCityName=''
        }
      },
      deep:true,
      immediate:true
    }

  }
}
</script>
  <style lang="less" scoped>
  @import './index';

  .tabbar {
    display: flex;
    // justify-content: center;
    justify-content: space-between;
  }

  .service-div {
    float: right;
    padding-top: 20px;
    padding-right: 20px;
  }

  .service-right {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: right;
  }

  .van-tag {
    margin-right: 15px;
  }

  .wrap-lc {
    margin: 0 12px;
    border-radius: 0.1rem;
    overflow: auto;
    //background-color: rgb(241 244 248);
  }



  .s1 {
    position: relative;
    left: -16px;
    top: 14px
  }

  .ertong {
    text-align: right;
  }

  .ertong1 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 5px 0 0 0;
  }
  .tow_disti{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 2px;
  }
  .mag_to_bt{
    width:50%;
    // margin-bottom: 6px;
  }

  .trip_rigt{
    display: flex;
    justify-content: flex-end;
    padding-right: 15px;
    margin-bottom:16px ;
  }
  .stroke /deep/ .van-tabs__line{
    width: 24px;
    height: 2.2px;
  }
  .wid_trip{
    display: flex;
    width: 100%;
    justify-content: center;

  }
  .triptypebox{
    display: flex;
    justify-content: center;
    width: 80%;

     /deep/ .trip-type{
        // border: 1px solid #5555 !important;
        background-color: #f1f4f8 !important;
        height:auto;
        display: flex;
        padding:3px;
     }

    /deep/ .triptype_box{
      width:100%
    }
    /deep/ .actived-left , /deep/ .actived-right{
      width:50%;
      height: 28px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #000;
      font-size: 14px;
    }

  }
  .tow_disti /deep/  .van-tab.van-tab--active{
    background-color: initial
  }

  </style>
